import {Avatar, Badge} from 'antd'
import classNames from 'classnames'
import {LocalContext} from 'modules/local/LocalContext'
import Translate from 'modules/local/Translate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {staticPaths} from 'routes/staticPaths'
import {NullAsDefault} from 'views/Shared'
import {LoginContext} from "../../components/LoginContext";
import {BsBellFill, BsSearch} from "react-icons/bs";
import {IoChatbubblesSharp} from "react-icons/io5";
import useAsyncAction from "../../modules/asyncCache/useAsyncAction";
import {notification_getReminderOnTime_Api} from "../../apis";
import _ from 'lodash';

const defaultItems = [
  // {
  //   label: 'introduce',
  //   to: {
  //     pathname: '/start',
  //   },
  // },
  // {
  //   label: 'discovery',
  //   to: {
  //     pathname:
  //       staticPaths.discovery.pathname,
  //   },
  // },
]

const useTodayRemindersCount = () => {
    const [count, setCount] = useState(0)

    const {handleAsyncAction} = useAsyncAction({
        apiInfo: notification_getReminderOnTime_Api,
        onSuccess: (result, data) => {
            const student = _.get(data, 'response.data.student_timetables', [])
            const teacher = _.get(data, 'response.data.teacher_timetables', [])
            const org = _.get(data, 'response.data.organization_timetables', [])
            setCount((student?.length || 0) + (teacher?.length || 0) + (org?.length || 0))
        },
    })

    useEffect(() => {
        handleAsyncAction()
    }, [])

    return count
}

const DefaultActions = () => {
    const history = useHistory()
    const {lang} = useContext(LocalContext)
    const login = useContext(LoginContext)
    const todayScheduleCount = useTodayRemindersCount()

    return (
        <div className="flex md:hidden gap-3 flex-center">
            <Link to={staticPaths.messages}>
                <Badge dot={login?.count_msg_notifications > 0 && true} className="flex custom-badge-header">
                    <Avatar
                        size={28}
                        icon={<IoChatbubblesSharp size={18} className={classNames("text-color-500", login?.count_msg_notifications > 0 && 'animate-ring')}/>}
                        className="flex flex-center background-200"
                    />
                </Badge>
            </Link>
            <Link to={{pathname: '/notifications'}}>
                <Badge count={(login?.count_notifications || 0) + todayScheduleCount} size="small" className="flex custom-badge-header">
                    <Avatar
                        size={28}
                        icon={<BsBellFill size={18} className={classNames("text-color-500", ((login?.count_notifications > 0) || todayScheduleCount > 0) && 'animate-ring')}/>}
                        className="flex flex-center background-200"
                    />
                </Badge>
            </Link>
            <Avatar
                size={28}
                icon={<BsSearch size={18}
                                onClick={() => {
                                    history.push({
                                        pathname: staticPaths.search.pathname,
                                        state: {isModal: true,},
                                    })
                                }}
                                className="text-color-500"/>}
                className="flex flex-center background-200"
            />
        </div>
    )
}

const HeaderNavigation = ({items = defaultItems, ExtraActions = NullAsDefault}) => (
  <React.Fragment>
    <Translate>
      {(t) => (
        <nav className="hidden md:flex items-center">
          {items.map(({label, to}, index) => (
            <h2 key={index}>
              <Link
                to={to.pathname}
                className={classNames(
                  'px-6 font-bold uppercase 111-111',
                  index === 0
                    ? 'color-primary'
                    : 'text-color-200 hover:text-primary'
                )}>
                {t(label)}
              </Link>
            </h2>
          ))}
        </nav>
      )}
    </Translate>
    <div className="flex items-center px-3">
      <DefaultActions/>
      <ExtraActions/>
    </div>
  </React.Fragment>
)
export default HeaderNavigation
